import React from 'react';

const EyePlus = ({fill = 'white', width = 30, height = 30}) => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
        <title></title>
        <g id="icomoon-ignore">
        </g>
        <path d="M512 64h-64v-64h-64v64h-64v64h64v64h64v-64h64z"></path>
        <path
            d="M431.931 223.014c9.218 10.239 17.596 21.265 25.011 32.986-19.146 30.261-44.637 55.961-74.718 75.148-37.797 24.109-81.445 36.852-126.224 36.852-44.78 0-88.43-12.743-126.227-36.852-30.078-19.186-55.568-44.886-74.715-75.148 19.146-30.262 44.637-55.962 74.717-75.148 1.959-1.25 3.938-2.461 5.931-3.65-4.981 13.664-7.706 28.411-7.706 43.798 0 70.691 57.308 128 128 128 70.69 0 128-57.309 128-128 0-0.346-0.009-0.69-0.012-1.036-54.642-14.069-95.149-63.315-95.966-122.155-10.513-1.19-21.197-1.809-32.022-1.809-111.659 0-208.441 65.021-256 160 47.559 94.979 144.341 160 256 160 111.655 0 208.438-65.021 256-160-8.82-17.615-19.338-34.197-31.325-49.527-14.64 8.589-31.136 14.355-48.744 16.541zM208 160c26.51 0 48 21.491 48 48s-21.49 48-48 48-48-21.49-48-48 21.49-48 48-48z"></path>
    </svg>
);

export default EyePlus;
